import { atom, useAtom, useAtomValue } from "jotai";
import { atomWithStorage } from "jotai/utils";

const emptyState = {
	q: "",
	type: "all",
	creator_id: undefined,
	match_student_id: undefined,
	tags: [],
	assignees: [],
	teams: [],
};

const tasksFilterAtom = atomWithStorage("tasks-filter", emptyState);

const isFilteredAtom = atom((get) => {
	const filter = get(tasksFilterAtom);
	if (
		filter?.q ||
		filter.type !== "all" ||
		filter?.creator_id ||
		filter?.match_student_id ||
		filter?.tags?.length ||
		filter?.assignees?.length ||
		filter?.teams?.length
	) {
		return true;
	}
	return false;
});

export default function useTasksFilter() {
	const [filter, setFilter] = useAtom(tasksFilterAtom);
	const isFiltered = useAtomValue(isFilteredAtom);

	const set = (value: any) => {
		setFilter((state) => ({
			...state,
			...value,
		}));
	};

	const clear = () => setFilter(emptyState);

	return {
		filter,
		isFiltered,
		actions: {
			set,
			clear,
		},
	};
}
